import { FC, useEffect, useState } from "react";

const startX = 11.4516;
const finishX = 107.7;

interface IBatteryProps {
    value: number;
}

const darkenColor = (color: string, factor: number) => {
    let r = parseInt(color.slice(1, 3), 16);
    let g = parseInt(color.slice(3, 5), 16);
    let b = parseInt(color.slice(5, 7), 16);
    
    r = Math.round(r - factor);
    g = Math.round(g - factor);
    b = Math.round(b - factor);
  
    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));
  
    return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase()}`;
}

const generateChargeColor = (percentage: number) => {
    percentage = Math.max(0, Math.min(100, percentage));
    let red, green, blue;
    
    if (percentage <= 50) {
        red = 255;
        green = Math.round((percentage / 50) * 255);
        blue = 0;
    } else {
        red = Math.round((1 - (percentage - 50) / 50) * 255);
        green = 255;
        blue = 0;
    }
  
    const hexColor = `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
    return hexColor.toUpperCase();
}

export const BatterySvg: FC<IBatteryProps> = ({ value }) => {
    const [color, setColor] = useState('');
    const [pos, setPos] = useState(0);

    useEffect(() => {
        setColor(generateChargeColor(value));
        const normValue = Math.min(100, Math.max(0, value));
        setPos((finishX - startX) * normValue * 0.01 + startX);
    }, [value]);

    if (color === '')
        return <></>;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="119"
            height="50"
            viewBox="0 0 119 50"
            fill="none"
        >
            <g clipPath={`url(#clip${value})`}>
                <path
                    d="M107 0L12 5.15567e-06V50H107C107 33.6694 107 16.2763 107 0Z"
                    fill="#E1EBEC"
                />
                <path
                    d={`M${pos} 2.05655e-06L11.4516 0C5.7015 -2.5135e-07 6.035e-07 11.1937 0 25C-6.035e-07 38.8062 5.70149 50 11.4516 50H${pos}V2.05655e-06Z`}
                    fill={`url(#paint0_linear_${value})`}
                />
                
                <path
                    d={`
                        M${pos} 50
                        C${pos - 3.314} 50 ${pos - 6.6} 38.8062 ${pos - 6.6} 25
                        C${pos - 6.6} 11.1937 ${pos - 3.314} 0 ${pos} 0
                        C${pos + 3.314} 0 ${pos + 5.4} 11.1937 ${pos + 5.4} 25
                        C${pos + 5.4} 38.8062 ${pos + 3.314} 50 ${pos} 50
                        Z
                    `}
                    fill={ darkenColor(color, 60) }
                />

                <path
                    d="M107.25 50C103.107 50 99 38.8062 99 25C99 11.1937 103.107 -1.81074e-07 107.25 0C111.392 1.81074e-07 114 11.1937 114 25C114 38.8062 111.392 50 107.25 50Z"
                    fill={ 'rgba(153, 170, 181, 0.5)' }
                />
                <path
                    d="M111.084 42.4502C112.659 38.9542 113.723 32.4433 113.723 24.9684C113.723 17.4935 112.659 10.9825 111.084 7.48654V4.7605H108.445C105.529 4.7605 103.167 13.8076 103.167 24.9684C103.167 36.1292 105.529 45.1762 108.445 45.1762H111.084V42.4502Z"
                    fill="#99AAB5"
                />
                <path
                    d="M105.806 24.9684C105.806 36.1289 108.168 45.1762 111.083 45.1762C113.998 45.1762 116.361 36.1289 116.361 24.9684C116.361 13.8079 113.998 4.7605 111.083 4.7605C108.168 4.7605 105.806 13.8079 105.806 24.9684Z"
                    fill="#CCD6DD"
                />
                <path
                    d="M116.361 16.8855H112.403C110.946 16.8855 109.764 20.5047 109.764 24.9686C109.764 29.4326 110.946 33.0518 112.403 33.0518H116.361V16.8855Z"
                    fill="#99AAB5"
                />
                <path
                    d="M113.722 24.9686C113.722 29.4328 114.904 33.0517 116.361 33.0517C117.819 33.0517 119 29.4328 119 24.9686C119 20.5044 117.819 16.8854 116.361 16.8854C114.904 16.8854 113.722 20.5044 113.722 24.9686Z"
                    fill="#CCD6DD"
                />
            </g>

            <defs>
                <linearGradient
                    id={`paint0_linear_${value}`}
                    x1={ pos }
                    y1="25"
                    x2="0"
                    y2="25"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={ color } />
                    <stop offset="1" stopColor={ darkenColor(color, 160) } />
                </linearGradient>

                <clipPath id={`url(#clip${value})`}>
                    <rect width="119" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}